import { CMS_API_BASE_URL } from 'configs/rest';

export const CMSImage = (imageSrc) => CMS_API_BASE_URL + imageSrc;
